<template>
  <div id="original-expansion-panel">
    <v-expansion-panels v-model="openPanelIndex" :disabled="disabled" multiple>
      <v-expansion-panel class="rounded-lg">
        <div>
          <slot name="header" />
          <v-spacer> </v-spacer>
        </div>
        <v-divider> </v-divider>
        <v-expansion-panel-content>
          <slot name="content" />
        </v-expansion-panel-content>
        <div v-if="isFooter">
          <v-divider> </v-divider>
          <slot name="footer" />
        </div>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
export default {
  props: {
    isFooter: { default: false }
  },
  data: () => {
    return {
      openPanelIndex: [0],
      disabled: false
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
#original-expansion-panel::v-deep .v-expansion-panel-content__wrap {
  padding: 0 !important;
}
</style>
